export enum TransactionType {
    Deposit = 1,
    Withdraw = 2,
    RemittancePayment = 3,
    DepositAtMerchant = 4,
    WithdrawAtMerchant = 5,
    Transfer = 6, //Transfer money between 2 customers wallets
    RequestFund = 7,
    MerchantPayment = 8,
    WithdrawRequest = 9, // transactions are staged transactions for Wallet. Transaction doesn't change the wallet balance unless its confirmed
    WithdrawConfirm = 10,
    WithdrawRequestAtMerchant = 11,  // transactions are staged transactions for Wallet. Transaction doesn't change the wallet balance unless its confirmed
    WithdrawConfirmAtMerchant = 12, 
    CustomerJomPayCashIn = 13, // deposit using Jompay
    MerchantJomPayCashIn = 14, // deposit using Jompay
    SystemCredit = 15,
    SystemDebit = 16,
    TransferToBank = 17,
    CommissionCredit = 18,
    MerchantToMerchantTransfer = 19,
    MerchantCashOut = 22,
    
    Unknown = 99,
    RetailPaymentRefund = 20,
    RemittancePaymentRefund = 21,
    WallettoBankAccount = 23,
    WalletFundedInwardRemittance = 24,
    CardATMWithdrawal = 25, //prepaid card transactions type list start
    CardECOM = 27,
    walletCardFee = 28,
    walletCardFeeRefund = 67,
    CardPOS = 29,
    CustomerPOSTransfer = 39,
    CustomerDebit = 40,
    WithdrawCash = 42,
    CreditAdjustment = 43,
    RequestOrderReversal = 44,
    BalanceEnquiry = 45,
    RequestCashAdvance = 46,
    CashAtCounter = 47,
    CustomerFundRequest = 49,
    CardIssuanceChargeVirtual = 51,
    CardEcommerceTransaction = 52,
    CardEcommerceAccountVerification = 54, //prepaid card transactions end
    Disbursement = 55,
    PayDuitNow = 57,
    DuitNowFailed = 58,
    DomensticMobileTopup = 31,
    InternationalMobileTopup = 32,
    DomensticBillPay = 33,
    InternationalBillpay = 34,
    DomensticMobileTopupFailed = 59,
    InternationalMobileTopupFailed = 60,
    DomensticBillPayFailed = 61,
    InternationalBillpayFailed = 62,
    BillPaymentDomestic = 37,
    BillPaymentInternational = 38,
    BillPaymentDomesticRefund = 61,
    BillPaymentInternationalRefund = 62,
    DuitNowQRReceive = 111,
    DuitNowP2PTransfer = 112,
    DuitNowP2PTransferFailed = 113,
    CDMDeposit = 110
}

export enum LimitFrequencyType {
    Unknown = 0,
    Daily = 1,
    Monthly = 2
}
/* * updated based on table 
* https://coda.io/d/Ria-Wallet-Documentation_d27n6iNLTyz/API-reference_suLbT
* https://euronet.atlassian.net/browse/OM-3257?focusedCommentId=369296
*/


// WEBPACK FOOTER //
// ./src/model/types/wallet-transactiontype-type.ts